import { render, staticRenderFns } from "./GalleryPicker.vue?vue&type=template&id=a4a2d8de&"
import script from "./GalleryPicker.vue?vue&type=script&lang=js&"
export * from "./GalleryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GalleryPicker.vue"
export default component.exports